// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__16_fS","insightsList":"newBusinessInsightsMenu_insightsList__3TNur","active":"newBusinessInsightsMenu_active__2scSL"};